import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import { FormInput } from "../../components/FormInput";
import NoInfo from "../../components/NoInfo";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { mailNoticeRecords, queryNoticeRecordsList, updateNoticeRecords } from "../../utility/service/notice-service";
import { addDate, checkDpSuccess, getFormErrorMessage, setformate } from "../../utility/service/tool-service";
import { useEditableFlag } from "../../hooks/useEditableFlag";

export default function NoticeRecord_Index() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [noticeSeq, setNoticeSeq] = useState('');
    const [delDialog, setDelDialog] = useState(false);
    const [delObj, setDelObj] = useState({});
    const [mailDialog, setMailDialog] = useState(false);
    const [mailObj, setMailObj] = useState({});
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const { itemObj, setItemObj, action, setAction } = useOutletContext();
    const [releaseStatusList, setReleaseStatusList] = useState([]);
    const isEditable = useEditableFlag('B20201');


    const esgClientId = [
        {
            label: t('company.a'),
            value: 'A'
        },
        {
            label: t('company.b'),
            value: 'B'
        },
        {
            label: t('company.m'),
            value: 'M'
        },
    ]


    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
    } = useForm({
        defaultValues: {
            keywordSearch: '',
            releaseStatus: '0',
        },
        //錯誤驗證時機
        mode: "all"
    });


    const onSubmit = (data) => {
        let reqBody = {
            queryStartTime: setformate(data.queryStartTime, "YYYY/MM/DD"),
            queryEndTime: setformate(data.queryEndTime, "YYYY/MM/DD"),
            keywordSearch: data.keywordSearch,
            releaseStatus: data.releaseStatus
        }
        axios_queryNoticeRecordsList(reqBody);

    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    function initDate() {
        let date = new Date();
        let SDate = setformate(addDate(date, -6), "YYYY-MM-DD");
        let EDate = setformate(new Date(addDate(date, +6)), "YYYY-MM-DD");
        setValue("queryStartTime", new Date(SDate), { shouldValidate: true });
        setValue("queryEndTime", new Date(EDate), { shouldValidate: true });
    }

    const editItem = (rowData) => {
        navigate("detail");
        setAction('detail');
        setItemObj(rowData);
    }

    const deleteItem = (rowData) => {
        setDelDialog(true);
        setDelObj(rowData)
    }

    const confirmDel = () => { //作廢公告
        let reqBody = {
            noticeSeq: delObj?.noticeSeq,
            releaseStatus: "1"
        }
        axios_updateNoticeRecords(reqBody);
    }

    const mailItem = (rowData) => {
        setMailDialog(true);
        setMailObj(rowData)
    }

    const confirmSend = () => {
        let reqBody = {
            noticeSeq: mailObj?.noticeSeq,
        }
        axios_mailNoticeRecords(reqBody);
    }

    const axios_mailNoticeRecords = (reqBody) => {
        mailNoticeRecords(reqBody)
            .then((res) => {
                if (checkDpSuccess(res)) {
                    handleSuccessMessage(dispatch, t('button.mail') + ' ' + t('message.success'));
                    let req = {
                        queryStartTime: setformate(getValues("queryStartTime"), "YYYY/MM/DD"),
                        queryEndTime: setformate(getValues("queryEndTime"), "YYYY/MM/DD"),
                        keywordSearch: getValues("keywordSearch"),
                        releaseStatus: getValues("releaseStatus")
                    }
                    setDelDialog(false);
                    setMailDialog(false);
                    axios_queryNoticeRecordsList(req);
                }
            })
    }

    const axios_updateNoticeRecords = (reqBody) => {
        updateNoticeRecords(reqBody)
            .then((res) => {
                if (checkDpSuccess(res)) {
                    handleSuccessMessage(dispatch, t('cancelled') + ' ' + t('message.success'));
                    let req = {
                        queryStartTime: setformate(getValues("queryStartTime"), "YYYY/MM/DD"),
                        queryEndTime: setformate(getValues("queryEndTime"), "YYYY/MM/DD"),
                        keywordSearch: getValues("keywordSearch"),
                        releaseStatus: getValues("releaseStatus")
                    }
                    setDelDialog(false);
                    setMailDialog(false);
                    axios_queryNoticeRecordsList(req);
                }
            })
    }

    const axios_releaseStatusList = () => {
        getSubItemsByItemNo('RELEASE_STATUS', 19)
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let data = res.data.RespBody.subItems;
                    let newArray = data.map((item, index) => {
                        return {
                            ...item,
                            index: index,
                        }
                    })
                    setReleaseStatusList(newArray);
                }
            })
    }

    const btnReadMore = () => {
        let reqBody = {
            queryStartTime: setformate(getValues("queryStartTime"), "YYYY/MM/DD"),
            queryEndTime: setformate(getValues("queryEndTime"), "YYYY/MM/DD"),
            keywordSearch: getValues("keywordSearch"),
            releaseStatus: getValues("releaseStatus"),
            noticeSeq: noticeSeq,
        }
        axios_queryNoticeRecordsList(reqBody, true);
    }

    const createItem = () => {
        navigate("create");
        setAction('create');
    }

    const actionBodyTemplate = (rowData, props) => {
        if (rowData) {
            return (
                <>
                    <Button tooltip={t('button.detail')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { editItem(rowData) }}>
                        <FontAwesomeIcon icon="fa-solid fa-eye" />
                    </Button>
                    <Button tooltip={t('button.mail')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" disabled={!isEditable} onClick={() => { mailItem(rowData) }}>
                        <FontAwesomeIcon icon="fa-solid fa-envelope" />
                    </Button>
                    <Button tooltip={t('cancelled')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" disabled={!isEditable} onClick={() => { deleteItem(rowData) }}>
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                    </Button>
                </>

            )

        }
    }

    const releaseStatusBodyTemplate = (rowData, props) => {
        if (rowData) {
            return (
                <>
                    {
                        rowData?.releaseStatus === '0' ? <span className="p-tag p-tag-success">{t('effective')}</span> : <span className="p-tag p-tag-danger">{t('withdraw')}</span>
                    }
                </>)
        }
    }

    const mailStatusBodyTemplate = (rowData, props) => {
        if (rowData) {
            return (
                <>
                    {
                        rowData?.mailStatus === '0' ? <span className="p-tag p-tag-success">{t('send')}</span> : <span className="p-tag p-tag-danger">{t('unsent')}</span>
                    }
                </>)
        }
    }

    const transUseType = (input) => {
        const values = input?.split('|');
        // 創建一個映射從 value 到 label
        const valueToLabel = esgClientId?.reduce((acc, item) => {
            acc[item.value] = item.label;
            return acc;
        }, {});
        // 根據值映射標籤
        const labels = values?.map(value => valueToLabel[value]);
        const result = labels?.join('|');
        return result;
    }

    const releaseTimeBodyTemplate = (rowData) => {
        if (rowData) {
            return (
                <>
                    {rowData?.releaseStartTime} ~ {rowData?.releaseEndTime}
                </>
            )
        }

    }

    // 身分別轉換
    const useTypeBodyTemplate = (rowData, props) => {
        if (rowData) {
            return (
                <>
                    {transUseType(rowData?.useTypes)}
                </>)
        }
    }

    const axios_queryNoticeRecordsList = (reqBody, readMore = false) => {
        queryNoticeRecordsList(reqBody)
            .then((res) => {
                if (checkDpSuccess(res)) {
                    let data = res?.data?.RespBody?.noticeRecordsList;
                    if (data?.length > 0) {
                        setNoticeSeq(data[data?.length - 1].noticeSeq);
                        if (readMore === true) {
                            setRows((pre) => {
                                return [...pre, ...data]
                            })
                        } else {
                            setRows((pre) => {
                                return [...data]
                            });
                        }
                    } else {
                        if (readMore === false) {
                            setRows([]);
                        }
                    }

                } else {
                    if (readMore === false) {
                        setRows([]);
                    }
                }
            })
    }

    useEffect(() => {
        axios_releaseStatusList();
        initDate();
        setValue("releaseStatus", "0");
        let reqBody = {
            queryStartTime: setformate(getValues("queryStartTime"), "YYYY/MM/DD"),
            queryEndTime: setformate(getValues("queryEndTime"), "YYYY/MM/DD"),
            keywordSearch: getValues("keywordSearch"),
            releaseStatus: getValues("releaseStatus")
        }
        axios_queryNoticeRecordsList(reqBody);
    }, [])


    return (<>
        <div className="p-card bg-gray">
            <div className="p-card-body">
                <form className="col-12" onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
                    <div className="grid">

                        <div className='col-12 lg:col-8'>

                            <label
                                htmlFor="executionDate"
                                className="form-label required">
                                {t('postingTime')}
                            </label>

                            <div className="col-date-picker">

                                <Controller
                                    name="queryStartTime"
                                    control={control}
                                    rules={{
                                        required: { value: true, message: t('validation.required') },
                                        validate: (val) => {
                                            if ((val !== "" && watch('queryEndTime') !== '') && watch('queryEndTime') < val) return t('validation.startDate')
                                        },
                                    }}
                                    render={({
                                        field,
                                        fieldState,
                                        formState,
                                    }) => (
                                        <Calendar
                                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                            dateFormat='yy-mm-dd'
                                            value={field.value || ''}
                                            onChange={(e) => {
                                                field.onChange(e.value)
                                                if (e.value < watch("queryEndTime")) {
                                                    clearErrors("queryEndTime")
                                                }
                                            }}
                                            showIcon />
                                    )} />
                                {getFormErrorMessage(errors, "queryStartTime")}

                                <Controller
                                    name="queryEndTime"
                                    control={control}
                                    rules={{
                                        required: { value: true, message: t('validation.required') },
                                        validate: (val) => {
                                            if ((val !== '' && watch('queryStartTime') !== '') && watch('queryStartTime') > val) return t('validation.endDate')
                                        },
                                    }}
                                    render={({
                                        field,
                                        fieldState,
                                        formState,
                                    }) => (
                                        <>
                                            <Calendar
                                                className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                                dateFormat='yy-mm-dd'
                                                value={field.value || ''}
                                                onChange={(e) => {
                                                    field.onChange(e.value);
                                                    if (e.value > watch("queryStartTime")) {
                                                        clearErrors("queryStartTime")
                                                    }
                                                }}
                                                showIcon />

                                        </>

                                    )} />
                                {getFormErrorMessage(errors, "queryEndTime")}
                            </div>
                        </div>
                        {/* 上架狀態 */}
                        <div className='col-12 lg:col-4'>
                            <label
                                htmlFor="releaseStatus"
                                className="form-label required">
                                {t("status")}
                            </label>
                            <Controller
                                name="releaseStatus"
                                control={control}
                                // rules={setValidForm('industryCode')}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        filter
                                        optionLabel="subitemName"
                                        optionValue="subitemNo"
                                        value={field.value}
                                        virtualScrollerOptions={{ itemSize: 40 }}
                                        defaultValue={""}
                                        placeholder={t("plz_chs")}
                                        name="releaseStatus"
                                        control={control}
                                        options={releaseStatusList}
                                        className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                                        onChange={(event) => {
                                            field.onChange(event.value);
                                        }}
                                    />
                                )}
                            />
                            {getFormErrorMessage(errors, "releaseStatus")}
                        </div>

                        <div className="col-12 lg:col-12">
                            <FormInput
                                register={register}
                                errors={errors}
                                id="keywordSearch"
                                type="text"
                                placeholder={``}
                                labelClass="control-label"
                                enterClick={checkKeyDown}
                                labelText={t('keyword')}

                            />
                        </div>


                    </div>


                    <div className="col-12 gap-2 flex-all-center">
                        <Button disabled={!isValid} type="submit" label={t("button.query")} />
                        <Button outlined type="button" disabled={!isEditable} onClick={() => { createItem(); }} label={t("button.createNotice")} />
                    </div>


                </form>


            </div>
        </div>
        <div className="p-card">
            <div className="p-card-body">
                <DataTable
                    stripedRows
                    className="white-data-table hover-highlight no-shadow"
                    tableStyle={{ minWidth: '55rem' }}
                    value={rows}
                    footer={rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />}
                    emptyMessage={<NoInfo panel="table" />}
                >
                    <Column field="title" header={t('title')} />
                    <Column field="useTypes" body={useTypeBodyTemplate} header={t('useType')} />
                    <Column field="releaseStartTime" header={t('postingTime')} body={releaseTimeBodyTemplate} />
                    <Column field="releaseStatus" header={t('releaseStatus')} body={releaseStatusBodyTemplate} />
                    <Column field="mailStatus" header={t('mailStatus')} body={mailStatusBodyTemplate} />
                    <Column style={{ width: 'auto' }} body={actionBodyTemplate} header={t('action')} frozen alignFrozen="right" />
                </DataTable>
            </div>

        </div>

        {/* 刪除 */}
        <PrimeConfirmDialog
            visible={delDialog}
            onClose={() => { setDelDialog(false) }}
            onConfirm={() => { confirmDel(); }}
            title={t('cancelled')}
            bodyTemplate={t('cancelAnnounce')}
        />

        {/* 寄送 */}
        <PrimeConfirmDialog
            visible={mailDialog}
            onClose={() => { setMailDialog(false) }}
            onConfirm={() => { confirmSend(); }}
            title={t('mailStatus')}
            bodyTemplate={t('confirmSend')}
        />

    </>)
}